import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

const EXPRESSION_TRIGGER_PATTERN = /^[n@+-]$/i;

/**
 * Returns true if the keyboard event carries a modifier combination that
 * represents a shortcut (Ctrl+C, Cmd+A, …) rather than character input.
 */
function hasShortcutModifier(event: ReactKeyboardEvent): boolean {
  // Meta key is a shortcut modifier on MacOS (Cmd+C, Cmd+A, …).
  if (event.metaKey) {
    return true;
  }

  if (event.ctrlKey) {
    // Ctrl+Alt is AltGr on Windows/Linux — allow those through.
    // On macOS there is no AltGr, so Ctrl+Alt is a regular shortcut.
    const isMac = navigator.userAgent.toLowerCase().includes('mac');
    if (!event.altKey || isMac) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the key event represents a relative-timeframe character
 * that should trigger a switch from iso8601 to expression mode.
 */
export function isExpressionTriggerKey(event: ReactKeyboardEvent): boolean {
  if (hasShortcutModifier(event)) {
    return false;
  }
  return EXPRESSION_TRIGGER_PATTERN.test(event.key);
}
